import React from 'react';

export function SearchBar({ placeholder = 'Buscar...', onSearch, value, onChange }) {
  return (
    <div className="nc-search">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="11" cy="11" r="8" />
        <path d="M21 21l-4.35-4.35" />
      </svg>
      <input
        type="text"
        className="nc-search__input"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        aria-label={placeholder}
        onKeyDown={(e) => e.key === 'Enter' && onSearch?.(value)}
      />
      {value && (
        <button type="button" className="nc-search__clear" aria-label="Limpar busca" onClick={() => onChange?.('')}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="1.8">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      )}
    </div>
  );
}
